import React, { useMemo } from 'react';
import MUIAvatar from '@mui/material/Avatar';
import randomcolor from 'randomcolor';
import { useTheme } from '../styles';
export const Avatar = props => {
  const theme = useTheme();
  const {
    colorSeed,
    style,
    ...restProps
  } = props;
  const newStyle = useMemo(() => {
    if (colorSeed) {
      const color = randomcolor({
        luminosity: 'light',
        seed: colorSeed || 'test'
      });
      return {
        ...style,
        backgroundColor: color,
        color: theme.palette.getContrastText(color)
      };
    }
    return {
      ...style
    };
  }, [colorSeed]);
  const newProps = {
    ...restProps,
    style: newStyle
  };
  return /*#__PURE__*/React.createElement(MUIAvatar, newProps);
};
export default Avatar;